import { createFileRoute } from '@tanstack/react-router';
import logoWhite from '@/images/logoWhite.svg';
import { Video, ShieldCheck, Sparkles } from 'lucide-react';

export const Route = createFileRoute('/linkedin-ad')({
  component: LinkedInAdPage,
});

function LinkedInAdPage() {
  return (
    <div
      style={{
        width: '800px',
        height: '800px',
        position: 'relative',
        overflow: 'hidden',
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}>
      {/* Background with layered gradient */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(135deg, #050505 0%, #0a0a0a 25%, #080b12 50%, #050505 100%)',
        }}
      />

      {/* Gradient orbs */}
      <div
        style={{
          position: 'absolute',
          top: '-100px',
          right: '-60px',
          width: '420px',
          height: '420px',
          borderRadius: '50%',
          background:
            'radial-gradient(circle, rgba(170, 231, 61, 0.15) 0%, transparent 70%)',
          filter: 'blur(60px)',
        }}
      />
      <div
        style={{
          position: 'absolute',
          bottom: '-80px',
          left: '-40px',
          width: '350px',
          height: '350px',
          borderRadius: '50%',
          background:
            'radial-gradient(circle, rgba(59, 130, 246, 0.12) 0%, transparent 70%)',
          filter: 'blur(50px)',
        }}
      />
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '500px',
          height: '500px',
          borderRadius: '50%',
          background:
            'radial-gradient(circle, rgba(170, 231, 61, 0.04) 0%, transparent 60%)',
          filter: 'blur(80px)',
        }}
      />

      {/* Content */}
      <div
        style={{
          position: 'relative',
          zIndex: 10,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          height: '100%',
          padding: '72px 64px',
          gap: '48px',
        }}>
        {/* Logo */}
        <div>
          <img
            src={logoWhite}
            alt="GreetAI"
            style={{ height: '52px', width: 'auto' }}
          />
        </div>

        {/* Headline */}
        <div>
          <h1
            style={{
              fontSize: '64px',
              fontWeight: 700,
              color: '#ffffff',
              lineHeight: 1.12,
              letterSpacing: '-0.025em',
              margin: 0,
              marginBottom: '28px',
            }}>
            Prescreen candidates
            <br />
            in just{' '}
            <span
              style={{
                background:
                  'linear-gradient(135deg, #AAE73D 0%, #7bc62d 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}>
              a few minutes
            </span>
          </h1>

          <p
            style={{
              fontSize: '24px',
              color: 'rgba(255,255,255,0.5)',
              margin: 0,
              lineHeight: 1.5,
            }}>
            AI voice agents that interview, record, and score candidates — so
            you only review the best.
          </p>
        </div>

        {/* Feature Pills */}
        <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
          <FeaturePill icon={<Video size={20} />} label="Video Recording" />
          <FeaturePill icon={<ShieldCheck size={20} />} label="Cheat Detection" />
          <FeaturePill icon={<Sparkles size={20} />} label="Premium AI Models" />
        </div>
      </div>

      {/* Bottom accent bar */}
      <div
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '3px',
          background:
            'linear-gradient(90deg, transparent 0%, #AAE73D 30%, #7bc62d 50%, #AAE73D 70%, transparent 100%)',
        }}
      />
    </div>
  );
}

function FeaturePill({
  icon,
  label,
}: {
  icon: React.ReactNode;
  label: string;
}) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '14px 26px',
        borderRadius: '999px',
        background: 'rgba(255,255,255,0.06)',
        border: '1px solid rgba(255,255,255,0.1)',
        backdropFilter: 'blur(8px)',
      }}>
      <span style={{ color: '#AAE73D', display: 'flex' }}>{icon}</span>
      <span
        style={{
          fontSize: '18px',
          fontWeight: 500,
          color: 'rgba(255,255,255,0.85)',
        }}>
        {label}
      </span>
    </div>
  );
}

